<template>
  <layout width="428">
    <template slot="header"> {{ isNew ? 'Add' : 'Edit' }} schema</template>

    <template>
      <v-form autocomplete="off" ref="form" v-model="isValid" lazy-validation>
        <div class="mx-4">
          <subheader>General info</subheader>
          <v-text-field
            data-test-schema="name"
            v-model="localEntity.name"
            label="Nаme *"
            autocomplete="off"
            :rules="[rules.required]"
            :error="!!errors.name"
            :error-messages="errors.name"
            clearable
          ></v-text-field>
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            data-test-schema="type"
            v-model="localEntity.schemaType"
            label="Type *"
            item-text="name"
            :rules="[rules.required]"
            :error="!!errors.name"
            :error-messages="errors.name"
            clearable
            item-value="id"
            :items="types"
            class="ma-0"
          >
            <template v-slot:item="{ item }">
              <div :data-test-name-value="item.name">
                {{ item.name }}
              </div>
            </template>
          </v-select>
          <v-autocomplete
            clearable
            data-test-schema="applicationOwner"
            :rules="[rules.required]"
            :error="!!errors.name"
            :error-messages="errors.name"
            v-model="applicationOwner"
            :search-input.sync="searchUser"
            :items="appsList"
            item-text="name"
            item-value="id"
            return-object
            :loading="loadingUser"
            label="Application owner *"
            class="ma-0"
          >
            <template v-slot:item="{ item }">
              <div :data-test-owner-value="item.name">
                {{ item.name }}
              </div>
            </template>
          </v-autocomplete>
          <div class="d-flex align-center mx-0">
            <div style="font-size: 16px">Enabled</div>
            <v-spacer />
            <v-switch
              data-test-switch="enabled"
              class="ma-0 py-3"
              hide-details
              v-model="localEntity.enabled"
            ></v-switch>
          </div>
          <subheader>Contact info</subheader>
          <v-text-field
            v-model="localEntity.mAuthor"
            label="Author"
            clearable
          ></v-text-field>
          <v-text-field
            v-model="localEntity.mEmail"
            label="Emаil"
            clearable
          ></v-text-field>
          <v-text-field
            v-model="localEntity.mVersion"
            label="Version"
            clearable
          ></v-text-field>
          <v-text-field
            v-model="localEntity.mManufacturer"
            label="Manufacturer"
            clearable
          ></v-text-field>
          <v-text-field
            v-model="localEntity.mExternalId"
            label="External ID"
            clearable
          ></v-text-field>
          <v-combobox
            v-model="localEntity.mTags"
            multiple
            label="Tags"
            append-icon
            item-color="green"
            clearable
            chips
            class="ma-0"
          >
            <template v-slot:selection="data">
              <v-chip color="primary" small>
                {{ data.item }}
              </v-chip>
            </template>
          </v-combobox>
          <subheader>Photo</subheader>

          <media-input
            v-model="formDataPicture"
            :id="mPicture"
            rules="image|size:20"
          />
          <subheader>Icon</subheader>

          <media-input
            v-model="formDataIcon"
            :id="mIcon"
            rules="image|size:20"
          />
          <subheader>Description</subheader>
          <v-textarea
            v-model="localEntity.description"
            no-resize
            rows="1"
            auto-grow
          ></v-textarea>
        </div>
      </v-form>
    </template>

    <template slot="footer">
      <v-spacer />
      <v-btn text @click.stop="close">
        cancel
      </v-btn>
      <v-btn color="primary" :loading="loadingScheme" text @click.stop="save">
        <template v-if="isNew">add</template>
        <template v-else>save</template>
      </v-btn>
    </template>
  </layout>
</template>

<script>
import Layout from '@/layouts/LayoutPopup';
import useSchemas from '@/api/schemas';
import useUser from '@/api/users';
import debounce from 'lodash.debounce';
import uniqby from 'lodash.uniqby';
import MediaInput from '@/components/MediaInput';
import useMedia from '@/compositions/useMedia';

export default {
  name: 'editScheme',
  props: {
    entity: {
      type: [Object],
      required: true
    }
  },
  components: {
    Layout,
    MediaInput
  },
  data: () => ({
    isValid: true,
    loadingScheme: false,
    imagesError: {
      mPicture: [],
      mIcon: []
    },
    rules: {
      required: value => !!value || 'Required.',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      }
    },
    options: {
      bgColor: 'transparent',
      textColor: 'white',
      showTitle: false,
      shadow: true
    },
    appsList: [],
    searchUser: '',
    loadingUser: false,
    applicationOwner: null,
    mPicture: '',
    mPictureFile: null,
    mPictureFileProgress: 0,
    mIcon: '',
    mIconFile: null,
    mIconFileProgress: 0,
    formDataPicture: 0,
    formDataIcon: 0,
    localEntity: {
      defaultTtl: '',
      description: '',
      enabled: true,
      mAuthor: '',
      mEmail: '',
      mExternalId: '',
      mIcon: '',
      mLongname: '',
      mManufacturer: '',
      mPicture: '',
      mTags: '',
      mVersion: '',
      name: '',
      type: ''
    },
    errors: {},
    api: new useSchemas(),
    apiApps: new useUser(),
    media: new useMedia()
  }),
  watch: {
    searchUser(val) {
      if (val !== null) {
        this.apiApps.users.setParams({
          filter: {
            login: { includesInsensitive: val }
          }
        });
        this.loadUsers();
      } else {
        this.apiApps.users.setParams({
          filter: null
        });
      }
    }
  },
  computed: {
    tags() {
      return [];
    },
    types() {
      return [
        {
          id: 'DEVICE',
          name: 'device'
        },
        {
          id: 'MEDIA',
          name: 'media'
        },
        {
          id: 'DATASET',
          name: 'dataset'
        },
        {
          id: 'APPLICATION',
          name: 'application'
        }
      ];
    },
    isNew() {
      return !this.localEntity.id;
    }
  },
  methods: {
    loadUsers: debounce(function() {
      this.loadingUser = true;
      return this.apiApps.users
        .load()
        .then(res => {
          let arr = [
            ...res.usersConnection.edges.map(app => ({
              name: app.node.login,
              id: app.node.id
            }))
          ];
          if (this.applicationOwner) {
            arr.push(this.applicationOwner);
          }
          this.appsList = uniqby(arr, 'id');
        })
        .finally(() => {
          this.loadingUser = false;
        });
    }, 400),
    close() {
      this.$emit('close');
    },
    uploadFiles() {
      let promises = [];
      if (this.formDataPicture) {
        promises.push(
          this.media.uploadMedia(this.formDataPicture).then(res => {
            return {
              id: res.data,
              type: 'picture'
            };
          })
        );
      } else {
        if (this.formDataPicture === null) {
          this.localEntity.mPicture = null;
        }

        if (this.formDataPicture === 0) {
          this.localEntity.mPicture = this.entity.mPicture;
        }
      }
      if (this.formDataIcon) {
        promises.push(
          this.media.uploadMedia(this.formDataIcon).then(res => {
            return {
              id: res.data,
              type: 'icon'
            };
          })
        );
      } else {
        if (this.formDataIcon === null) {
          this.localEntity.mIcon = null;
        }

        if (this.formDataIcon === 0) {
          this.localEntity.mIcon = this.entity.mIcon;
        }

      }
      return Promise.all(promises);
    },
    removeFalsy(obj) {
      let newObj = {};
      Object.keys(obj).forEach(prop => {
        if (obj[prop] || prop === 'enabled') {
          newObj[prop] = obj[prop];
        }
      });
      newObj.type = newObj.schemaType;
      delete newObj.schemaType;
      return newObj;
    },
    async save() {
      this.$refs.form.validate();
      await this.$nextTick();
      if (this.isValid) {
        this.loadingScheme = true;
        if (this.localEntity.id) {
          return this.uploadFiles()
            .then(r => {
              return this.api.schema.updateSchema(this.localEntity.id, {
                name: this.localEntity.name,
                enabled: this.localEntity.enabled,
                mAuthor: this.localEntity.mAuthor,
                mEmail: this.localEntity.mEmail,
                mVersion: this.localEntity.mVersion,
                mTags: this.localEntity.mTags,
                mManufacturer: this.localEntity.mManufacturer,
                type: this.localEntity.schemaType,
                id: this.localEntity.id,
                description: this.localEntity.description,
                mExternalId: this.localEntity.mExternalId,
                mPicture:
                  r.find(el => el.type === 'picture')?.id ||
                  this.localEntity.mPicture,
                mIcon:
                  r.find(el => el.type === 'icon')?.id ||
                  this.localEntity.mIcon,
                applicationOwner: this.applicationOwner.id || null
                // mLongname: ,
              });
            })
            .then(r => {
              this.appsList = [];
              this.searchUser = '';
              this.$emit('save', r);
              this.close();
            })
            .finally(() => {
              this.api.schema.loading = false;
            });
        } else {
          return this.uploadFiles()
            .then(r => {
              this.localEntity.mPicture = r.find(
                el => el.type === 'picture'
              )?.id;
              this.localEntity.mIcon = r.find(el => el.type === 'icon')?.id;
              return this.api.schemas.save({
                schema: {
                  ...this.removeFalsy(this.localEntity),
                  applicationOwner: this.applicationOwner.id
                }
              });
            })
            .then(r => {
              this.appsList = [];
              this.searchUser = '';
              this.$emit('save', r);
              this.close();
            })
            .finally(() => {
              this.api.schema.loading = false;
              this.loadingScheme = false;
            });
        }
      }
    },
    upload(field) {
      this.$refs[field].click();
    }
  },
  mounted() {
    if (this.entity.id) {
      this.localEntity = { ...this.entity };
      if (this.entity.userByApplicationOwner) {
        this.applicationOwner = {
          id: this.entity.userByApplicationOwner.id,
          name: this.entity.userByApplicationOwner.login
        };
        this.appsList = uniqby([...this.appsList, this.applicationOwner], 'id');
      }

      if (this.entity.mPicture) {
        this.mPicture = this.entity.mPicture;
      }

      if (this.entity.mIcon) {
        this.mIcon = this.entity.mIcon;
      }
    }
    this.loadUsers();
  }
};
</script>

<style lang="scss" scoped>
.user_photo {
  position: relative;
  background-color: #dbdbdb;
  background-position: center;
  min-height: 120px;
}

.upload {
  position: absolute;
  top: 15px;
  right: 15px;
}

.shadow {
  background-color: rgba(0, 0, 0, 0.44) !important;
  border-color: rgba(0, 0, 0, 0.44) !important;
}
</style>
